import EntityBase from '@/data/EntityBase';

export default class AnnotationState extends EntityBase({}) {}
